/**
 * ReceiptIcon/index.js
 * desc: receipt icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const ReceiptIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="receipt icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.receipt.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 18 20" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 18.5L0 20V0l1.5 1.5L3 0l1.5 1.5L6 0l1.5 1.5L9 0l1.5 1.5L12 0l1.5 1.5L15 0l1.5 1.5L18 0v20l-1.5-1.5L15 20l-1.5-1.5L12 20l-1.5-1.5L9 20l-1.5-1.5L6 20l-1.5-1.5L3 20l-1.5-1.5zM15 5v2H3V5h12zM3 9v2h12V9H3zm0 4v2h12v-2H3z" /></svg>
    </IconButton>
);


export default ReceiptIcon;
